export interface BaseMenuItem {
  id?: string;
  route: string;
  label: string;
  claims?: string[];
  denyClaims?: string[];
  enabled: boolean;
  isBeta?: boolean;
  enabledUsingSelfSignup?: boolean;
  selfSignupLabel?: string;
}

export interface NavigationMenu {
  mainItems: NavMenuItem[];
  organizationItems: NavMenuItem[];
  reportItems: NavMenuItem[];
  settingsItems: NavMenuItem[];
}

export interface NavMenuItem extends BaseMenuItem {
  isExternal?: boolean;
  externalUrl?: string;
  isDropdownTrigger?: boolean;
  categoryId?: CategoryId;
}

export enum CategoryId {
  Reports = 1,
  Organization,
  Interviews,
  Main,
}
